import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../../enums';
import { beforeEnter } from '../../guards';

const Component = () => import('./AgilysysSiteIntegration.vue');

// /sites/:siteId/site-settings/integration/agilysys
export default {
  path: buildChildURL(
    SitesRoutePathNames.SITE,
    SitesRoutePathNames.SETTINGS,
    SitesRoutePathNames.INTEGRATION,
    SitesRoutePathNames.AGILYSYS,
  ),
  name: SitesRouteNames.SITE_SETTINGS_AGILYSYS,
  component: Component,
  beforeEnter: beforeEnter,
} as RouteRecordRaw;
